import { Smartphone, TrendingUp, Layout, Zap } from 'lucide-react';

export const LandingFeatures = () => {
  return (
    <section id="features" className="py-24 lg:py-32 bg-gray-50 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6">

        {/* Section Header */}
        <div className="mb-16 lg:mb-24">
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8">
            <div className="max-w-2xl">
              <h2 className="text-5xl lg:text-7xl font-black tracking-tight leading-[1] mb-6">
                Fácil de usar.<br />Em qualquer lugar.
              </h2>
              <p className="text-xl lg:text-2xl text-gray-500 font-medium tracking-tight">
                Gerencie toda a sua rede de telas pelo navegador ou pelo aplicativo.
              </p>
            </div>
            <div className="bg-gray-900 text-white px-6 py-4 rounded-full border border-gray-800 hidden lg:flex items-center gap-4">
              <Zap className="text-primary w-6 h-6" />
              <span className="font-black text-sm uppercase tracking-widest">Painel Watch Station</span>
            </div>
          </div>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">

          {/* Card 1: Multiplataforma (Feature Destaque) */}
          <div className="md:col-span-2 md:row-span-2 bg-white p-10 lg:p-14 rounded-[40px] border border-gray-100 flex flex-col justify-between group hover:border-gray-900 transition-colors shadow-sm hover:shadow-2xl">
            <div>
              <div className="flex gap-4 mb-10">
                <div className="w-16 h-16 bg-gray-900 rounded-2xl flex items-center justify-center text-primary">
                  <Smartphone className="w-8 h-8" />
                </div>
                <div className="w-16 h-16 bg-gray-100 rounded-2xl flex items-center justify-center text-gray-900">
                  <Layout className="w-8 h-8" />
                </div>
              </div>
              <h3 className="text-3xl lg:text-5xl font-black mb-6 leading-tight text-gray-900">Multi-Plataforma</h3>
              <p className="text-lg lg:text-xl text-gray-500 font-medium leading-relaxed">
                Atualize conteúdos das telas do seu estabelecimento direto do{' '}
                <span className="text-gray-900">computador</span> do escritório ou pelo{' '}
                <span className="text-gray-900">smartphone</span> em casa.
              </p>
            </div>
            <div className="mt-12 rounded-3xl overflow-hidden transition-all duration-700 border border-gray-50">
              <img
                src="/images/wdeskmobile.webp"
                className="w-full h-64 object-cover"
                alt="Painel Desktop"
              />
            </div>
          </div>

          {/* Card 2: Venda Mais */}
          <div className="md:col-span-2 bg-primary p-10 lg:p-14 rounded-[40px] text-white flex flex-col justify-center shadow-lg shadow-primary/20">
            <div className="flex items-center gap-6 mb-6">
              <TrendingUp className="w-12 h-12" />
              <h3 className="text-4xl lg:text-5xl font-black">Faturamento Real</h3>
            </div>
            <p className="text-lg lg:text-2xl font-medium leading-relaxed opacity-95">
              Não apenas exiba vídeos. Crie funis de venda visuais que incentivam o cliente a comprar produtos de maior margem.
            </p>
          </div>







        </div>
      </div>
    </section>
  );
};
